export const DEFAULT_COMPONENTS = '@/components/ui';
export const DEFAULT_UTILS = '@/lib/utils';
export const DEFAULT_STYLE = 'tailwind';
export const DEFAULT_TAILWIND_CONFIG = 'tailwind.config.js';
export const INIT_COMMAND = 'npx sigma-ui init';
export const CONFIG_FILE_PATH = 'sigma-ui.config.json';

export const TAILWIND_CSS_PATH = {
  nuxt: 'assets/css/tailwind.css',
  vite: 'src/assets/index.css',
  laravel: 'resources/css/app.css',
  astro: 'src/styles/globals.css',
};
